export const actionTypes = {
    GET_USERS: 'users/getUsers',
    GET_USER: 'users/getUser',
    UPDATE_USER: 'users/updateUser',
    SIGN_IN: 'users/signIn',
    LOGOUT: 'users/logout',
};